var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-spacer',_vm._g(_vm._b({},'v-spacer',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }